query getConnection {
    konstantine {
        getConnection {
            id
            companyId
            apiKey
            status
        }
    }
}
